import styled from "styled-components";
import theme from "theme";

export const StepBarSection = styled.div`
    display: flex;
    align-items: center;
    gap: 2px;
`;

export const StepBar = styled.div<{ isActive?: boolean }>`
    width: 119px;
    height: 5px;
    border-radius: 1rem;
    background-color: ${({ isActive }) =>
        isActive ? theme.colors.purple.primary : theme.colors.grey.tertiary2};
`;
